import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PayService } from 'src/app/service/pay.service';

@Component({
    selector: 'app-information',
    templateUrl: './information.component.html',
    styleUrls: ['./information.component.css'],
    standalone: false
})
export class InformationComponent implements OnInit {
  userid: any;
  accountid: any;
  achatslist: any[] = [];
  depotslist: any[] = [];
  retraitlist: any[] = [];
  mensuelist: any[] = [];
  accountBalance: any;
  accountNumber: String;
  firstName: any;
  lastName: any;
  sigle: any;
  phone: any;
  qSecret: any;
  rSecret: any;
  secretPin: any;
  contrainPin: any;
  phoneList: any[];
  urlRecto: any;
  urlVerso: any;
  urlVersoMineur: any;
  urlRectoMineur: any;
  urlProfile: any;
  isActif: boolean;
  echeck: boolean;
  idConfirm: boolean;
  isenvoyer: boolean;

  readonly monthOptions = [
    { value: 1, label: 'Janvier' },
    { value: 2, label: 'Fevrier' },
    { value: 3, label: 'Mars' },
    { value: 4, label: 'Avril' },
    { value: 5, label: 'Mai' },
    { value: 6, label: 'Juin' },
    { value: 7, label: 'Juillet' },
    { value: 8, label: 'Aout' },
    { value: 9, label: 'Septembre' },
    { value: 10, label: 'Octobre' },
    { value: 11, label: 'Novembre' },
    { value: 12, label: 'Decembre' }
  ];

  achatsYearOptions: number[] = [];
  depotsYearOptions: number[] = [];
  retraitsYearOptions: number[] = [];
  mensualitesYearOptions: number[] = [];

  selectedAchatsMonth: number | null = null;
  selectedAchatsYear: number | null = null;
  selectedDepotsMonth: number | null = null;
  selectedDepotsYear: number | null = null;
  selectedRetraitsMonth: number | null = null;
  selectedRetraitsYear: number | null = null;
  selectedMensualitesMonth: number | null = null;
  selectedMensualitesYear: number | null = null;

  constructor(private userService: PayService, private routerActivate: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.routerActivate.params.subscribe(params => {
      // console.log(params) //log the entire params object
      this.userid = params['id'];
    });
    this.initUtilisateur();
  }

  initUtilisateur() {
    this.userService.getUtilisateur(this.userid).subscribe(data => {
      //console.log(data)
      this.phone = data['phone'];
      this.qSecret=data['question'];
      this.rSecret=data['reponse'];
      this.secretPin=data['secretpin'];
      this.contrainPin=data['contraintpin'];
      if(Boolean(data['confirmCNi'])==true)
      {
        this.idConfirm=true;
      }
      else{
        this.idConfirm=false;
      }
      this.getInformationsSurcompte();
    })
  }

  getInformationsSurcompte() {
    this.userService.getprimaryAccount(this.userid).subscribe(data => {
      this.accountid = data['id'];
      this.accountBalance = data['accountBalance'];
      this.accountNumber = String(data['accountNumber']);
      this.firstName = data['firstName'];
      this.lastName = data['lastName'];
      this.sigle = data['sigleMonnaie'];
      this.getAchats();
      this.getDepots();
      this.getRetraits();
      this.getMensualites();

    })
  }

  getRetraits() {
    this.userService.getprimaryAccountRetraits(this.accountid).subscribe((data: any[]) => {
      this.retraitlist = Array.isArray(data) ? data : [];
      this.retraitsYearOptions = this.buildYearOptions(this.retraitlist, 'retraits');

    })
  }

  getDepots() {
    this.userService.getprimaryAccountDepots(this.accountid).subscribe((data: any[]) => {
      this.depotslist = Array.isArray(data) ? data : [];
      this.depotsYearOptions = this.buildYearOptions(this.depotslist, 'depots');
      //console.log(data);

    })
  }
  getAchats() {
    this.userService.getprimaryAccountAchats(this.accountid).subscribe((data: any[]) => {
      this.achatslist = Array.isArray(data) ? data : [];
      this.achatsYearOptions = this.buildYearOptions(this.achatslist, 'achats');

    })
  }

  getMensualites() {
    this.userService.getprimaryAccountMensualite(this.accountid).subscribe((data: any[]) => {
      this.mensuelist = Array.isArray(data) ? data : [];
      this.mensualitesYearOptions = this.buildYearOptions(this.mensuelist, 'mensualites');

    })
  }

  getUserInfo()
  {
       this.userService.getUserContactTelephoniqueAdmin(this.userid).subscribe((data:any[])=>{
          this.phoneList=data;
         this.getUserIdentification();
       })
  }
  getUserIdentification()
  {
    this.userService.getUserIdentificationAdmin(this.userid).subscribe(data=>{
      
      //console.log(data);
      if(data['urlRecto']!=null)this.urlRecto=data['urlRecto']; else this.urlRecto="";
      if(data['urlVerso']!=null)this.urlVerso=data['urlVerso'];else this.urlVerso="";
      if(data['urlVersoMineur']!=null)this.urlVersoMineur=data['urlVersoMineur'];else this.urlVersoMineur="";
      if(data['urlRectoMineur']!=null)this.urlRectoMineur=data['urlRectoMineur'];else this.urlRectoMineur="";
      if(data['urlProfile']!=null)this.urlProfile=data['urlProfile'];else this.urlProfile="";
      
    })
  }

  ActivationCompte()
  {
    this.userService.activationCompteUtilisateur(this.userid).subscribe(data=>{
       if(data==0)
       {
         this.isActif=true;
          setTimeout(() => {
            this.isActif=false;
            this.initUtilisateur();
          }, 3000);
       }
       else
       {
        this.echeck=true;
        setTimeout(() => {
          this.echeck=false;
        }, 3000);
       }

    })
    //alert(this.userid);
  }

  desactivationCompte()
  {
    this.userService.desactiverCompteUtilisateur(this.userid).subscribe(data=>{
      this.initUtilisateur();

   })
  }

  emailAlert(typ:number)
  {
    this.userService.messageActivationImpossible(this.userid,typ).subscribe(data=>{
      console.log(data);
      if(data==0)
      {
        this.isenvoyer=true;
        setTimeout(() => {
          this.isenvoyer=false;
        }, 3000);
      }
    })
  }

  get utilisateurDisplayName(): string {
    const first = (this.firstName || "").trim();
    const last = (this.lastName || "").trim();
    const fullName = `${first} ${last}`.trim();
    return fullName.length > 0 ? fullName : "Cet utilisateur";
  }

  getEmptyTabMessage(tab: 'achats' | 'depots' | 'retraits' | 'mensualites'): string {
    if (this.hasActiveFilter(tab)) {
      return `Aucun resultat pour le filtre mois/annee selectionne (${this.utilisateurDisplayName}).`;
    }

    switch (tab) {
      case 'achats':
        return `${this.utilisateurDisplayName} n'a effectue aucun achat.`;
      case 'depots':
        return `${this.utilisateurDisplayName} n'a effectue aucun depot.`;
      case 'retraits':
        return `${this.utilisateurDisplayName} n'a effectue aucun retrait.`;
      case 'mensualites':
        return `Aucune mensualite disponible pour ${this.utilisateurDisplayName}.`;
      default:
        return "Aucune donnee disponible.";
    }
  }

  get filteredAchatsList(): any[] {
    return this.applyPeriodFilter(
      this.achatslist,
      this.selectedAchatsMonth,
      this.selectedAchatsYear,
      'achats'
    );
  }

  get filteredDepotsList(): any[] {
    return this.applyPeriodFilter(
      this.depotslist,
      this.selectedDepotsMonth,
      this.selectedDepotsYear,
      'depots'
    );
  }

  get filteredRetraitsList(): any[] {
    return this.applyPeriodFilter(
      this.retraitlist,
      this.selectedRetraitsMonth,
      this.selectedRetraitsYear,
      'retraits'
    );
  }

  get filteredMensualitesList(): any[] {
    return this.applyPeriodFilter(
      this.mensuelist,
      this.selectedMensualitesMonth,
      this.selectedMensualitesYear,
      'mensualites'
    );
  }

  resetPeriodFilter(tab: 'achats' | 'depots' | 'retraits' | 'mensualites'): void {
    if (tab === 'achats') {
      this.selectedAchatsMonth = null;
      this.selectedAchatsYear = null;
      return;
    }

    if (tab === 'depots') {
      this.selectedDepotsMonth = null;
      this.selectedDepotsYear = null;
      return;
    }

    if (tab === 'retraits') {
      this.selectedRetraitsMonth = null;
      this.selectedRetraitsYear = null;
      return;
    }

    this.selectedMensualitesMonth = null;
    this.selectedMensualitesYear = null;
  }

  hasActiveFilter(tab: 'achats' | 'depots' | 'retraits' | 'mensualites'): boolean {
    const month = this.getSelectedMonth(tab);
    const year = this.getSelectedYear(tab);
    return month != null || year != null;
  }

  private getSelectedMonth(tab: 'achats' | 'depots' | 'retraits' | 'mensualites'): number | null {
    if (tab === 'achats') {
      return this.selectedAchatsMonth;
    }
    if (tab === 'depots') {
      return this.selectedDepotsMonth;
    }
    if (tab === 'retraits') {
      return this.selectedRetraitsMonth;
    }
    return this.selectedMensualitesMonth;
  }

  private getSelectedYear(tab: 'achats' | 'depots' | 'retraits' | 'mensualites'): number | null {
    if (tab === 'achats') {
      return this.selectedAchatsYear;
    }
    if (tab === 'depots') {
      return this.selectedDepotsYear;
    }
    if (tab === 'retraits') {
      return this.selectedRetraitsYear;
    }
    return this.selectedMensualitesYear;
  }

  private buildYearOptions(
    list: any[],
    tab: 'achats' | 'depots' | 'retraits' | 'mensualites'
  ): number[] {
    const years = (Array.isArray(list) ? list : [])
      .map(item => this.extractYear(item, tab))
      .filter((value): value is number => value != null && !Number.isNaN(value));

    return Array.from(new Set(years)).sort((left, right) => right - left);
  }

  private applyPeriodFilter(
    list: any[],
    month: number | null,
    year: number | null,
    tab: 'achats' | 'depots' | 'retraits' | 'mensualites'
  ): any[] {
    const safeList = Array.isArray(list) ? list : [];
    if (month == null && year == null) {
      return safeList;
    }

    return safeList.filter(item => {
      const itemMonth = this.extractMonth(item, tab);
      const itemYear = this.extractYear(item, tab);
      const monthMatches = month == null || itemMonth === month;
      const yearMatches = year == null || itemYear === year;
      return monthMatches && yearMatches;
    });
  }

  private extractMonth(item: any, tab: 'achats' | 'depots' | 'retraits' | 'mensualites'): number | null {
    if (item == null) {
      return null;
    }

    if (tab === 'mensualites') {
      const monthValue = Number(item.month);
      return Number.isFinite(monthValue) ? monthValue : null;
    }

    if (!item.date) {
      return null;
    }

    const parsedDate = new Date(item.date);
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate.getMonth() + 1;
  }

  private extractYear(item: any, tab: 'achats' | 'depots' | 'retraits' | 'mensualites'): number | null {
    if (item == null) {
      return null;
    }

    if (tab === 'mensualites') {
      const yearValue = Number(item.annee);
      return Number.isFinite(yearValue) ? yearValue : null;
    }

    if (!item.date) {
      return null;
    }

    const parsedDate = new Date(item.date);
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate.getFullYear();
  }

}
